import { render, staticRenderFns } from "./SmartTablePagination.vue?vue&type=template&id=7bdc0e2c&"
import script from "./SmartTablePagination.vue?vue&type=script&lang=js&"
export * from "./SmartTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports